<p-avatar
      [label]="avatarImage() ? undefined : initials()"
      [image]="avatarImage() || undefined"
      [size]="size()"
      [style]="avatarStyle()"
      [class]="'font-semibold'"
      shape="circle"
    />